import gql from "graphql-tag";

const UBERUNS_SLIDER_QUERY = gql`
  query AboutUsSlider {
    aboutUs {
      data {
        attributes {
          slider {
            title
            slide(pagination: { limit: 25 }) {
              title
              thumb {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default UBERUNS_SLIDER_QUERY;
